export default __webpack_public_path__ + "static/media/i073hk.ea179469.webp";